import Login from "components/Login/Login";
import React from "react";

const LoginPage: React.FC = () => {
  return (
    <>
      <Login></Login>
    </>
  );
};

export default LoginPage;
